// src/components/operationCenter/widgets/token/overview/TwOrderBookWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import OrderBookDepthCard from "@/components/tokenPage/overview/OrderBookDepthCard";

const TwOrderBookWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  // symbol = ticker + "USDT" for Binance order book
  const symbol = config.ticker ? `${config.ticker.toUpperCase()}USDT` : "";
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={[]}>
        {symbol && <OrderBookDepthCard symbol={symbol} />}
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwOrderBookWidget;
